import React from 'react';

import { StyledItem } from './styles';

export interface Props {
  children?: JSX.Element | JSX.Element[];
  onClick?: (event: React.SyntheticEvent) => void;
  className?: string;
  testId?: string;
}

const ListItem = ({ children, onClick, className, testId }: Props) => (
  <StyledItem className={className || ''} onClick={onClick} data-testid={testId}>
    {children}
  </StyledItem>
);

export default ListItem;
